import React, { useCallback } from 'react';

import Recommendations from 'components/Recommendations';
import EntityCard from 'components/cards/EntityCard';

import CommonPropTypes from 'utils/propTypes/common';

const ConcertsRecommendationsBlock = ({ entities }) => {
	const renderCard = useCallback(
		(entity, onCardClick) => (
			<EntityCard
				_id={entity._id}
				image={entity.additionalThumbnailFile || entity.thumbnailFile}
				title={entity.title}
				onClick={onCardClick}
				size="elastic"
				theme={null}
			/>
		),
		[]
	);

	return (
		<Recommendations
			recommendations={entities}
			type="movies"
			renderCard={renderCard}
		/>
	);
};

ConcertsRecommendationsBlock.propTypes = {
	entities: CommonPropTypes.entities.isRequired
};

export default ConcertsRecommendationsBlock;
